import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import { dateFormatter } from "utilities";
import { fetchUnitList } from "actions/Units";
import { fetchZoneList } from "actions/Zones";
import ButtonContained from "components/ButtonContained";
import TableNew from "components/TableNew"
import { TenantIcon, EmployeeIcon, VendorIcon } from "utilities/iconsNew";
import IconWithBackground from "components/IconWithBackground";

const AddUserConfirm = ({formData, updateForm, onBack, onSubmit, facility, preSelectedUnit }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const authUser = useSelector((state) => state.auth.authUser);
  const units = useSelector((state) => state.units.unitsList);
  const schedules = useSelector((state) => state.settings.siteSchedules);
  const zones = useSelector((state) => state.zones.zoneList);
  useEffect(() => {
    if (formData.userType === "tenant") {
      dispatch(fetchUnitList(
        ["available"],
        undefined, undefined, undefined, undefined,
        undefined, undefined, undefined, undefined,
        {facilityUUID: facility.uuid, companyUUID: facility.companyUUID}
      ));
    }
    if (formData.userType === "limited") {
      dispatch(fetchZoneList(undefined, {facilityUUID: facility.uuid, companyUUID: facility.companyUUID}));
    }
  }, [dispatch]);

  const types = [
    {
      name: "tenant",
      icon: <TenantIcon />,
    },
    {
      name: "employee",
      icon: <EmployeeIcon />,
    },
    {
      name: "limited",
      icon: <VendorIcon />,
    },
  ];
  const type = types.find((type) => type.name === formData.userType);
  return (
    <div className="px-18 flex flex-col">
      <div className="flex gap-4">
        <div className="p-5 flex-1 flex flex-col items-center justify-center">
          {type.icon}
          <h5 className="pt-6 pb-2 tw-heading-5 text-[var(--color-blue-600)]">{formData.firstName} {formData.lastName}</h5>
          {formData.email !== "" && <div className="self-start">
            <p className="tw-paragraph-reg text-[var(--color-gray-400)]">{intl.formatMessage({ id: `form.email` })}</p>
            <p className="tw-paragraph-reg text-[var(--color-gray-600)]">{formData.email}</p>
          </div>}
          {formData.phone !== "" && <div className="self-start">
            <p className="tw-paragraph-reg text-[var(--color-gray-400)]">{intl.formatMessage({ id: `form.phone` })}</p>
            <p className="tw-paragraph-reg text-[var(--color-gray-600)]">+{formData.country.phone[0].toString()}{formData.phone}</p>
          </div>}
          {formData.userType === "limited" && formData.expirationDate && <div className="self-start">
            <p className="tw-paragraph-reg text-[var(--color-gray-400)]">{intl.formatMessage({ id: `comp.repeatSchedule.expirationDate` })}</p>
            <p className="tw-paragraph-reg text-[var(--color-gray-600)]">{dateFormatter(formData.expirationDate, authUser, facility && facility.sitePreferredDateFormat ? facility : undefined)}</p>
          </div>}
          <div className="self-start">
            <p className="tw-paragraph-reg text-[var(--color-gray-400)]">{intl.formatMessage({ id: `form.role` })}</p>
            <p className="tw-paragraph-reg text-[var(--color-gray-600)]">{formData.role.name}</p>
          </div>
          {formData.accessCode !== "" && <div className="self-start">
            <p className="tw-paragraph-reg text-[var(--color-gray-400)]">{intl.formatMessage({ id: `form.accessCode` })}</p>
            <p className="tw-paragraph-reg text-[var(--color-gray-600)]">{formData.accessCode}</p>
          </div>}
        </div>
        <div className="flex-1 flex flex-col gap-4">
          {formData.userType === "tenant" && <div>
            <h5 className="pt-6 pb-2 tw-heading-5 text-[var(--color-blue-600)]">{intl.formatMessage({ id: `form.select.unit` })}</h5>
            <div className="min-h-[40vh] max-h-[60vh] overflow-y-auto custom-scrollbar pr-2">
              {units && <TableNew
                data={units}
                defaultSortKey="name"
                searchableKeys={["name"]}
                singleSelect={true}
                requireSelection={true}
                showHeaders={false}
                preSelectedRows={[preSelectedUnit]}
                onSelectionChange={(rows) => updateForm("selectedUnits")(rows)}
                icon={<IconWithBackground
                  iconName="closedDoor"
                  backgroundColor="#E7E7E7"
                  className="text-[var(--color-gray-300)]"
                />}
                columns={[
                  {
                    key: "name",
                    label: "Name",
                    sortable: true
                  },
                ]}
              />}
            </div>
          </div>}
          {formData.userType === "employee" && <div>
            <h5 className="pt-6 pb-2 tw-heading-5 text-[var(--color-blue-600)]">{intl.formatMessage({ id: `comp.header.select.schedule` })}</h5>
            <div className="min-h-[40vh] max-h-[60vh] overflow-y-auto custom-scrollbar pr-2">
              {schedules && <TableNew
                data={schedules}
                selectionReference="userSiteHoursSuiteUUID"
                defaultSortKey="name"
                searchableKeys={["name"]}
                singleSelect={true}
                requireSelection={true}
                showHeaders={false}
                onSelectionChange={(rows) => updateForm("selectedSchedule")(rows)}
                icon={<IconWithBackground
                  iconName="schedule"
                  backgroundColor="#E7E7E7"
                  className="text-[var(--color-gray-300)]"
                />}
                columns={[
                  {
                    key: "name",
                    label: "Name",
                    sortable: true
                  },
                ]}
              />}
            </div>
          </div>}
          {formData.userType === "limited" &&  <div>
            <h5 className="pt-6 pb-2 tw-heading-5 text-[var(--color-blue-600)]">{intl.formatMessage({ id: `comp.header.select.zones` })}</h5>
            <div className="min-h-[40vh] max-h-[60vh] overflow-y-auto custom-scrollbar pr-2">
              {zones && <TableNew
                data={zones}
                defaultSortKey="Name"
                searchableKeys={["Name"]}
                multiSelect={true}
                showHeaders={false}
                onSelectionChange={(rows) => updateForm("selectedZones")(rows)}
                icon={<IconWithBackground
                  iconName="mapPin"
                  backgroundColor="#E7E7E7"
                  className="text-[var(--color-gray-300)]"
                />}
                columns={[
                  {
                    key: "name",
                    label: "Name",
                    sortable: true
                  },
                ]}
              />}
            </div>
          </div>}
        </div>
      </div>
      <div className="flex justify-between pt-6">
        <ButtonContained
          id="add-user-confirm-back-button"
          dataCy="add-user-confirm-back-button"
          text={intl.formatMessage({ id: `comp.button.back` })}
          type="mediumOutline"
          onClick={onBack}
        />
        <ButtonContained
          id="add-user-confirm-create-button"
          dataCy="add-user-confirm-create-button"
          text={intl.formatMessage({ id: `comp.button.create`})}
          type="mediumOutline"
          onClick={onSubmit}
        />
      </div>
    </div>
  )
}

export default AddUserConfirm;